export default __webpack_public_path__ + "images/FOPSOLOVI.27b6cba.png";